export default "__VITE_ASSET__UAVhWW0g__"